module.exports = __webpack_public_path__ + "img/Engagement_Somewhat_Engaged_32@2x.79105463.png";